module.exports = __webpack_public_path__ + "static/img/partner_XXI.abc57b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XXI.png
// module id = 581a
// module chunks = 9